import type {TestTab} from './TestHistoryPage.types'

export const TestPageTabNamesEnum = {
  OVERVIEW: 'overview',
  INVESTIGATION_HISTORY: 'investigationHistory',
}
export const tabs: Array<TestTab> = [
  {
    id: TestPageTabNamesEnum.OVERVIEW,
    title: 'Overview',
  },
  {
    id: TestPageTabNamesEnum.INVESTIGATION_HISTORY,
    title: 'Investigation History',
  },
]
